<template lang="pug">
modal#cancel-envelope-modal(
  :processButtonLabel='$t("button.ok")'
  :showCancelButton='false'
  :title='$t("modal.canceledEnvelope.title")'
  @process='close'
  ref='modal'
  size='sm'
)
  p.justify-center {{ $t('modal.canceledEnvelope.message') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/canceled-rejected-envelope.svg')
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  components: {
    Modal,
  },
  methods: {
    close() {
      this.$refs.modal.close();
    },
  },
};
</script>
